import eventMap from "./components/event-map";
import events from "./components/events";
import EventsCalendar from "./components/events-calendar";
import EventsEntity from "./components/events-entity";
import gallery from "./components/gallery.js";
import photoswipe from "./components/photoswipe.js";
import placeMap from "./components/place-map";
import tabs from "./components/tabs";

console.log("Started JS App Events");

events();
new EventsEntity(".js-events-entity");
new EventsCalendar();
eventMap(".js-event-map");
gallery();
photoswipe();
placeMap(".js-place-map");
tabs();
